<form #form="ngForm">

  <div class="tab-content">

    <div class="row">
      <h5>Input Switch</h5>

      <div class="col-2">
        <div class="d-flex justify-content-center search-slider-box">
          <span class="slider-text me-2">Left</span>
          <p-inputSwitch></p-inputSwitch>
          <span class="slider-text ms-2">Right</span>
        </div>
      </div>


      <div class="col-2">
        <div class="d-flex justify-content-center search-slider-box">
          <span class="slider-text me-2 disabled">Dis</span>
          <p-inputSwitch [disabled]="true"></p-inputSwitch>
          <span class="slider-text ms-2 disabled">Able</span>
        </div>
      </div>

    </div>

    <div class="row mt-5">
      <h5>Checkbox</h5>
      <div class="col-3">
        <p-checkbox id="cb" label="Check Me" [binary]="true"></p-checkbox>
      </div>
    </div>

    <div class="mt-5 row">
      <h5>Drop Down</h5>
      <div class="col-3">
        <label for='term' class="required">Term</label>
        <p-dropdown appDd id='term' name="term" class='ng-error' [showClear]='true' [(ngModel)]="term" [placeholder]="'Hello'" [options]="termOptions" [required]="true" [filter]="true"></p-dropdown>
      </div>

      <div class="col-3">
        <label for='termd' class="required">Disabled</label>
        <p-dropdown appDd id='termd' name="termd" [disabled]="true" [showClear]='true' [(ngModel)]="term" [placeholder]="'Hello'" [options]="termOptions" [required]="true" [filter]="true"></p-dropdown>
      </div>
      <div class="col-3">
        <label for='termr' class="required">Read Only</label>
        <p-dropdown appDd id='termr' name="termr" [readonly]="true" [(ngModel)]="term" [placeholder]="'Hello'" [options]="termOptions" [required]="true" [filter]="true"></p-dropdown>
      </div>
    </div>

    <div class="mt-5 row">
      <h5>Input Number</h5>
      <div class="col-2">
        <label id="maxPaymentLimitLabel" for="maxPaymentLimit" class="required form-label">Maximum Payment Limit</label>
        <!-- maxlength has a bug https://github.com/primefaces/primeng/issues/13704 -->
        <p-inputNumber appIn [(ngModel)]="limit" mode="currency" currency="USD" locale="en-US" [min]="0.01" [required]="true" id="limit" name="limit" [showButtons]="true"
          [max]="10000" [maxlength]="5" placeholder="Maximum Payment Limit"></p-inputNumber>
      </div>
      <div class="col-2">
        <label id="maxPaymentLimitLabel" for="maxPaymentLimit" class="required form-label">Maximum Payment Limit</label>
        <p-inputNumber appIn buttonLayout="horizontal" [(ngModel)]="limit" mode="currency" currency="USD" locale="en-US" [min]="0.01" [required]="true" id="limit" name="limit"
          [showButtons]="true" [max]="10000" placeholder="Maximum Payment Limit"></p-inputNumber>
      </div>
    </div>


    <div class="row mt-5">
      <h5>Radio Buttons</h5>
      <div class="col-3">

        <div class="d-flex flex-wrap gap-3">
          <div class="d-flex align-items-center">
            <p-radioButton name="paymentType" value="creditCard" [(ngModel)]="model.paymentType" inputId="creditCard"></p-radioButton>
            <label for="creditCard" class="ms-2">Credit Card</label>
          </div>
          <div class="d-flex align-items-center">
            <p-radioButton name="paymentType" value="ach" [(ngModel)]="model.paymentType" inputId="ach"></p-radioButton>
            <label for="ach" class="ms-2">ACH</label>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 row">
      <h5>Normal Input</h5>
      <div class="col-3">
        <label for='lastName' class="required">Generic Input</label>
        <input [(ngModel)]="model.lastName" appScrText required appLastNameValidator id='lastName' name="lastName" #lastName="ngModel" placeholder="Last Name" />
        <app-error-msg [field]="lastName" fieldLabel="Last Name"></app-error-msg>
      </div>

    </div>

    <div class="mt-5 row">
      <h5>Normal Text Area</h5>
      <div class="col-3">
        <label for="notes" class="required">Generic TextArea</label>
        <textarea class="form-control" required id="notes" name="notes" placeholder="Notes"></textarea>
      </div>

    </div>

    <div class="mt-5 row">
      <h5>Calendar</h5>
      <div class="col-3">
        <div class="col-auto">
          <label for="date" class="me-2">Date:</label>
          <p-calendar name="date" placeholder="Date" [showIcon]="true" inputId="date" [(ngModel)]="date" [showTime]="true" [hourFormat]="'24'" dateFormat="yy-mm-dd"></p-calendar>
        </div>
      </div>


      <div class="col-3">
        <div class="col-auto">
          <label for="ddate" class="me-2">Disabled:</label>
          <p-calendar [disabled]='true' name="ddate" placeholder="Disabled" [showIcon]="true" inputId="ddate" [(ngModel)]="ddate" [showTime]="true" [hourFormat]="'24'"
            dateFormat="yy-mm-dd"></p-calendar>
        </div>
      </div>
    </div>

    <div class="mt-5">
      &nbsp;
    </div>
  </div>
</form>